
import React, { createContext, useState } from 'react';

// Create the AuthContext
export const MenuContext = createContext<any>(
    {
        menuItems: [],
        setMenuItems: () => {}
    }
);

export const MenuProvider = ({ children }:any) => {

  const [menuItems, setMenuItems] = useState([]);

  return (
    <MenuContext.Provider value={{ menuItems, setMenuItems }}>
      {children}
    </MenuContext.Provider>
  );
};
